<template>
  <svg width="88" height="88" viewBox="0 0 88 88" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M18.7193 70H69.2807C74.451 70 77.6741 64.1085 75.0889 59.4164L49.8082 13.519C47.223 8.82699 40.777 8.82699 38.1918 13.519L12.9111 59.4164C10.3259 64.1085 13.549 70 18.7193 70ZM44 45.305C42.1535 45.305 40.6427 43.7175 40.6427 41.7772V34.7214C40.6427 32.7811 42.1535 31.1936 44 31.1936C45.8465 31.1936 47.3573 32.7811 47.3573 34.7214V41.7772C47.3573 43.7175 45.8465 45.305 44 45.305ZM47.3573 56.0591C47.3573 57.9133 45.8542 59.4164 44 59.4164C42.1458 59.4164 40.6427 57.9133 40.6427 56.0591V55.7181C40.6427 53.8639 42.1458 52.3607 44 52.3607C45.8542 52.3607 47.3573 53.8639 47.3573 55.7181V56.0591Z"
      class="class-fill"
    />
  </svg>
</template>
<style lang="scss">
.class-fill {
  fill: #e9e9ed;
}
.dark {
  .class-fill {
    fill: #2e2e38;
  }
}
</style>
